import React, { useState } from "react";
import useTimerCounter from "../hooks/use-timer";
import { useParams } from "react-router-dom";

export default function AcceptRules({ socket, data }) {
  const { m, s } = useTimerCounter(data.time.totalSecond);
  const [accepted, setAccepted] = useState(false);
  const { id } = useParams();
  const [exam_id, package_id] = [...id?.split("__")];
  return (
    <div className="text-lg font-dana-normal p-20">
      <pre className="font-dana-normal">{data.message}</pre>
      <pre className="font-dana-normal">{data.message}</pre>
      <div className="text-red-700 flex flex-row items-center gap-4 mt-5">
        زمان باقی مانده برای پذیرفتن قوانین و ورود به آزمون
        <span className="font-dana-bold w-[133px] text-2xl border border-primary-400 pt-1.5 px-10 rounded-md text-primary-400 flex justify-center items-center">{`${m}:${s}`}</span>
      </div>
      <form className="text-primary-600 flex flex-row items-center gap-2">
        <label htmlFor="accepted" className="cursor-pointer">
          {" "}
          موارد فوق را مطالعه کردم و قوانین پذیرفتم{" "}
        </label>
        <input
          type="checkbox"
          onClick={() => setAccepted(!accepted)}
          name="accepted"
          id="accepted"
        />
      </form>
      <button
        color="error"
        sx={{ mt: 3 }}
        disabled={!accepted}
        className="text-lg mt-5 p-2 px-3 duration-300 shadow-xl hover:bg-primary-700 bg-primary-600 text-white rounded-md !font-extralight !font-dana-normal disabled:bg-slate-300 disabled:text-white"
        onClick={() =>
          accepted &&
          socket.emit(
            "getexam",
            JSON.stringify({
              exam_id,
              package_id,
              accepted,
            })
          )
        }
      >
        شروع آزمون
      </button>
    </div>
  );
}
